export enum ToastSeverity {
    Info = 0,
    Good = 1,
    Warning = 2,
    Error = 3,
}
